import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import "./portal.css";
import { App } from "./App";
import { instalarRecargaPorChunk } from "./recarga";
import { aplicarTema, leerTema } from "./tema";

// Antes que nada: si esta pestaña quedó vieja tras publicar y falta un pedazo del código, recarga una vez.
instalarRecargaPorChunk();
// El tema (claro por omisión) se pone antes de pintar nada, para que no parpadee.
aplicarTema(leerTema());

// Fuentes de la maqueta (Bricolage Grotesque / Figtree / JetBrains Mono).
(() => {
  const href =
    "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700&family=Figtree:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap";
  if (document.querySelector(`link[href="${href}"]`)) return;
  for (const [rel, h, co] of [
    ["preconnect", "https://fonts.googleapis.com", false],
    ["preconnect", "https://fonts.gstatic.com", true],
    ["stylesheet", href, false],
  ] as const) {
    const l = document.createElement("link");
    l.rel = rel;
    l.href = h;
    if (co) l.crossOrigin = "";
    document.head.appendChild(l);
  }
})();

createRoot(document.getElementById("portal")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
